module.exports = __webpack_public_path__ + "static/media/Satellite-Installation-Technician-Worker_art.e8ebde74.png";